import gql from "graphql-tag";

export const themeFragment = gql`
  fragment ThemeFragment on Theme {
    id
    name
    active
    project {
      id
      name
      color
    }
    isFavoriteTheme
  }
`;

export const timesheetFragment = gql`
  fragment TimesheetFragment on TimesheetEntry {
    id
    duration
    createdAt
    updatedAt
    date
    invoiceId
    activityId
    theme {
      ...ThemeFragment
    }
    role: projectRole {
      id
      name
      hourlyRate
    }
    notes
  }
  ${themeFragment}
`;
